import type { Components, Theme } from "@mui/material";

export const autocompleteTheme: Components<Theme>["MuiAutocomplete"] = {
  defaultProps: {
    slotProps: {
      paper: {
        elevation: 4,
        sx: {
          borderRadius: (theme) => theme.borderRadius.sm,
        },
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // the rendering here seems to differ from the docs
      // so we're setting the color explicitly
      ".MuiAutocomplete-popupIndicator": {
        color: theme.palette.text.secondary,
      },
      ".MuiAutocomplete-clearIndicator": {
        color: theme.palette.text.secondary,
      },
    }),
    // same theming as MuiSelect
    paper: ({ theme }) => ({
      ".MuiAutocomplete-listbox": {
        padding: theme.spacing(1),
        maxHeight: 400,
      },
      ".MuiAutocomplete-option": {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
      },
    }),
  },
};
